import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import TextButton from 'Components/ComponentLibrary/Components/Uncategorized/TextButton';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dispatchAuthenticationFactorsRefresh } from 'Hooks/useRefreshEvent';
import { useSnackbarContext } from 'Context/SnackbarContext';

const useStyles = buildUseStyles('AuthenticationFactorModalActionModify', ((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(1)}px`,
  },
})));

const AuthenticationFactorModalActionModify = () => {
  const classes = useStyles();
  const { onSubmit, resource } = useMetaLayoutContext();
  const authenticationType = resource.selectedOptionPrompt('authenticationType');
  const { clearModalCollection } = useModalContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { displaySuccess } = useSnackbarContext();

  const handleDisableAuthenticationFactor = async () => {
    logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Disable', {
      eventProperties: {
        authenticationType,
      },
    });
    resource.attr('enabled', 'false');
    const resp = await onSubmit();

    if (resp) {
      displaySuccess(`${authenticationType} has been disabled.`);
      dispatchAuthenticationFactorsRefresh();
      clearModalCollection();
    }
  };

  return (
    <Box
      className={classes.root}
    >
      <TextButton
        fullWidth
        onClick={() => handleDisableAuthenticationFactor()
          }
        test={'security-settings-button-authentication-factor-modify-modal-disable'}
      >
        {'Disable'}
      </TextButton>
      <RoundedButton
        fullWidth
        onClick={() => clearModalCollection()}
        test={'security-settings-button-authentication-factor-success-close'}
      >
        {'Close'}
      </RoundedButton>
    </Box>
  );
};

export default AuthenticationFactorModalActionModify;
